import { fetcher } from "../fetcher";

const BASE = "/user-settings";

export const userSettingsService = {
  updateUser: async (payload: UpdateUserSettingsForm) => {
    return await fetcher(`${BASE}`, {
      method: "PATCH",
      schema: userSchema,
      body: payload,
    });
  },
  updateEmail: async (payload: UpdateEmailForm) => {
    return await fetcher(`${BASE}/update-email`, {
      method: "PATCH",
      schema: userSchema,
      body: payload,
    });
  },
};
